export const ADD_TRIPS_START = "ADD_TRIPS_START";
export const ADD_TRIPS_ERROR = "ADD_TRIPS_ERROR";
export const ADD_TRIPS_SUCCESS = "ADD_TRIPS_SUCCESS";

//Delete Trip
export const DELETE_TRIP_START = "DELETE_TRIP_START";
export const DELETE_TRIP_ERROR = "DELETE_TRIP_ERROR";
export const DELETE_TRIP_SUCCESS = "DELETE_TRIP_SUCCESS";

//Preview Tour Trip
//Delete Trip
export const PREVIEW_TOUR_TRIP_START = "PREVIEW_TOUR_TRIP_START";
export const PREVIEW_TOUR_TRIP_ERROR = "PREVIEW_TOUR_TRIP_ERROR";
export const PREVIEW_TOUR_TRIP_SUCCESS = "PREVIEW_TOUR_TRIP_SUCCESS";

//Trip Details
export const GET_TRIP_DETAILS_START = "GET_TRIP_DETAILS_START";
export const GET_TRIP_DETAILS_ERROR = "GET_TRIP_DETAILS_ERROR";
export const GET_TRIP_DETAILS_SUCCESS = "GET_TRIP_DETAILS_SUCCESS";


export const TRIP_ADDITIONAL_JSON_VALUE = "TRIP_ADDITIONAL_JSON_VALUE";
export const TRIP_ADDITIONAL_JSON_VALUE_SUCCESS = "TRIP_ADDITIONAL_JSON_VALUE_SUCCESS";
export const TRIP_ADDITIONAL_JSON_VALUE_ERROR = "TRIP_ADDITIONAL_JSON_VALUE_ERROR";